// @ts-nocheck
const rowsPerPageInit = 25;
const rowsPerPageInEventInit = Math.pow(10, 10);
export { rowsPerPageInit, rowsPerPageInEventInit };